import React from "react";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import { FormikValues } from "formik";
import { GenericApiResponse } from "src/app/api/AppApiClient";
import { InfoPerso } from "src/pages/finalisation/etapes/infoPerso/useValidationSchemaInfoPerso";
import { setPersonalInfo } from "src/app/api/FinalizationApi";
import useValidationSchemaInfoPerso from "src/pages/finalisation/etapes/infoPerso/useValidationSchemaInfoPerso";
import InfoPersoFormContent from "src/pages/finalisation/etapes/infoPerso/InfoPersoFormContent";
import { useFinalisation } from "src/pages/finalisation/FinalisationContext";
import { useAppState } from "src/app/state/StateProvider";

export type InfoPersoFormProps = {
  initialValues: InfoPerso;
  pageSuivante: (data: any) => void;
};


const InfoPersoForm = ({ initialValues, pageSuivante }: InfoPersoFormProps) => {

  const [value] = useFinalisation();
  const [{ langue }] = useAppState();

  const validationSchema = useValidationSchemaInfoPerso();
  const submitSuccessHandler = (result: GenericApiResponse<any>, values: FormikValues) => {
    pageSuivante(values);
  };

  return (
    <AppFormik
      enableReinitialize
      initialValues={initialValues}
      submitFormAPI={(values: InfoPerso) => setPersonalInfo(values, value.shortId, langue)}
      submitSuccessHandler={submitSuccessHandler}
      validationSchema={validationSchema}
    >
      <InfoPersoFormContent />
    </AppFormik>
  );

};

export default InfoPersoForm;